var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1122px",
    height: "349px",
    viewBox: "0 0 1122 349",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-4-\\u4F5C\\u696D\\u9078\\u629E\\u6642_placeholder",
    transform: "translate(-260.000000, -252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(260.000000, 252.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv0/GraphBase/Right",
    opacity: 0.6,
    transform: "translate(49.000000, 18.000000)",
    fill: "#E0E4E7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider",
    transform: "translate(0.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider",
    transform: "translate(0.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider",
    transform: "translate(0.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lv0/Divider",
    transform: "translate(0.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1072,
    height: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 13,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 65,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 117,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 169,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 221,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 8,
    y: 273,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 87,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 0,
    y: 321,
    width: 162,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 174,
    y: 321,
    width: 200,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 386,
    y: 321,
    width: 130,
    height: 28,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 273,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 459,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 1017,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 831,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9ECEF",
    x: 645,
    y: 287,
    width: 31,
    height: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 1122,
    height: 349
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.73cf52103f43c192c346b0bcbd30412e.svg";
export { ForwardRef as ReactComponent };